import { useQuery, useLazyQuery } from 'src/graphql';
import { converter } from 'src/utils/converter/converter';
import {
  JOB_EFFECTIVE_RELATION_QUERY,
  JOB_SHORT_RELATION_QUERY,
} from 'src/graphql/job/query';

export default (id, skip = false, short = true, base = false) => {
  let result;
  if (short) {
    result = useQuery(JOB_SHORT_RELATION_QUERY, {
      variables: { id },
      skip,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    });
  } else {
    result = useLazyQuery(JOB_EFFECTIVE_RELATION_QUERY, {
      variables: { id, base },
      skip,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    });
    if (!result[1].loading && result[1].called && result[1].data) {
      result[1].data.job = converter(result[1].data.jobEffective);
    }
  }

  return result;
};
